export const visit = (vm, at) => {
at({ "en": { "crm-links": { "backToPageName": { "back": "Back", "helpDesk": "Help Desk", "salesWorkspace": "Sales Workspace", "helpDeskBack": "Back to Help Desk", "variable": "Back to {{pageName}}" } } } });
};